import { render, staticRenderFns } from "./RecursiveMenuItem.vue?vue&type=template&id=0ecdacea"
import script from "./RecursiveMenuItem.vue?vue&type=script&lang=js"
export * from "./RecursiveMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports